module.exports = __webpack_public_path__ + "img/yonghubiaoqian.0e728608.svg";